import { StatisticsRepostDataType } from 'types/stats';

export const generalSummaryRepost = (statisticsData: StatisticsRepostDataType) => {
  const { channels } = statisticsData;

  let totalParticipants = 0;
  let totalViews = 0;
  let totalReposts = 0;
  let totalSell = 0;

  channels.forEach((channel) => {
    totalParticipants += channel.participants;
    totalViews += channel.views;
    totalReposts += channel.totalReposts;
    totalSell += channel.sell;
  });

  const repostViewPercentage = totalParticipants ? (totalViews / totalParticipants) * 100 : 0;
  const cpmViews = totalViews ? totalSell / (totalViews / 1000) : 0;

  return {
    totalParticipants,
    totalViews,
    totalReposts,
    totalChannels: channels.length,
    totalSell,
    repostViewPercentage,
    cpmViews,
  };
};
